import { handleActions } from 'redux-actions';
import { richTextFieldActions } from '../actions/richTextField';
const initialState = {
    meta: {
        addAttachments: 'succeeded',
    },
};
export const { richTextFieldAddAttachments, richTextFieldAddAttachmentsSucceeded, richTextFieldAddAttachmentsFailed, } = richTextFieldActions;
const richTextField = handleActions({
    [richTextFieldAddAttachments.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { addAttachments: 'loading' }) });
    },
    [richTextFieldAddAttachmentsSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { addAttachments: 'succeeded' }) });
    },
    [richTextFieldAddAttachmentsFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { addAttachments: 'failed' }) });
    },
}, initialState);
export default richTextField;
